import palette from '../palette';
import shadows from '../shadows';

const MuiCard = {
  styleOverrides: {
    root: {
      borderRadius: 4,
      boxShadow: shadows[11],
      // rendering cards with Link
      // causes all content to be underlined
      textDecoration: 'none',
    },
  },
  variants: [
    {
      props: { variant: 'news' },
      style: {
        ':hover': {
          '& .MuiSvgIcon-root': {
            opacity: 1,
          },
          '& .MuiTypography-news': {
            color: palette.secondary.main,
          },
        },
        borderRadius: 2,
        boxShadow: shadows[6],
      },
    },
    {
      props: { variant: 'table' },
      style: {
        ':hover': {
          cursor: 'pointer',
        },
        borderRadius: 2,
        boxShadow: shadows[1],
        marginBottom: 16,
      },
    },
    {
      props: { variant: 'loading' },
      style: {
        '@media max-width(900px)': {
          marginBottom: 0,
          width: '100%',
        },
        borderRadius: 2,
        boxShadow: shadows[6],
        marginBottom: 8,
        marginLeft: 8,
        marginRight: 8,
        marginTop: 8,
        width: 304,
      },
    },
  ],
};

export default MuiCard;
